import { render, staticRenderFns } from "./GuestsDescription.vue?vue&type=template&id=63b38416&"
import script from "./GuestsDescription.vue?vue&type=script&lang=js&"
export * from "./GuestsDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports